import { render, staticRenderFns } from "./FactorNewDialog.vue?vue&type=template&id=8fb4beb6"
import script from "./FactorNewDialog.vue?vue&type=script&lang=js"
export * from "./FactorNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports